export default "__VITE_ASSET__fbuvu9eN__"